import { REGION } from '../../const/config';

const colorByRegion = REGION === 'ru' ? 'green' : 'white'

const menuItems = [
  {
    title: 'список новостей',
    route: '/news',
    caption: 'Новости',
    extraClass: colorByRegion,
    regions: ['ru', 'ca', 'by'],
  },
  {
    title: 'список статей',
    route: '/articles',
    caption: 'Статьи',
    extraClass: colorByRegion,
    regions: ['ru', 'ca', 'by'],
  },
  {
    title: 'список онлайнов',
    route: '/onlines',
    caption: 'Онлайны',
    extraClass: colorByRegion,
    regions: ['ru', 'ca', 'by'],
  },
  {
    title: 'список сюжетов',
    route: '/chronicles',
    caption: 'Сюжеты',
    extraClass: colorByRegion,
    regions: ['ru', 'ca', 'by'],
  },
  {
    title: 'список тестов',
    route: '/tests',
    caption: 'Тесты',
    extraClass: colorByRegion,
    regions: ['ru', 'ca', 'by'],
  },
  {
    title: 'список карточек',
    route: '/cards',
    caption: 'Расклады',
    extraClass: colorByRegion,
    regions: ['ru', 'by'],
  },
  {
    title: 'список подкастов',
    route: '/podcasts',
    caption: 'Подкасты',
    extraClass: colorByRegion,
    regions: ['ru', 'by'],
  },
  {
    title: 'управление темами',
    route: '/themes',
    icon: 'icon hashtag',
    regions: ['ru', 'ca', 'by'],
  },
  {
    title: 'инструменты',
    icon: 'suitcase icon',
    regions: ['ru', 'ca', 'by'],
    submenu: [
      {
        title: 'все пользователи',
        caption: 'Все пользователи',
        route: '/users',
        icon: 'icon users',
        regions: ['ru', 'ca', 'by'],
      },
      {
        title: 'технические страницы',
        caption: 'Технические страницы',
        route: '/pages',
        icon: 'icon folder outline',
        regions: ['ru', 'ca', 'by'],
        roles: ['admin'],
      },
      {
        title: 'отчёт о просмотрах',
        caption: 'Отчёт о просмотрах',
        route: '/analytic_reports',
        icon: 'icon clipboard list',
        regions: ['ru'],
        roles: ['editor', 'admin'],
      },
      {
        title: 'рекламные кампании',
        caption: 'Рекламные кампании',
        route: '/advertCampaigns',
        icon: 'icon money outline',
        regions: ['ru'],
      },
      {
        title: 'партнеры для материалов',
        caption: 'Партнеры для материалов',
        route: '/partners',
        icon: 'icon newspaper outline',
        regions: ['ru'],
      },
    ],
  },
  {
    title: 'отчёты об ошибках',
    route: '/reports',
    icon: 'icon edit',
    regions: ['ru', 'ca', 'by'],
  },
  {
    title: 'фичеры главной страницы',
    route: '/features',
    icon: 'icon star empty',
    regions: ['ru', 'ca', 'by'],
  },
  {
    title: 'список отправленных уведомлений',
    route: '/pushes',
    icon: 'icon bell outline',
    regions: ['ru', 'ca', 'by'],
  },
  {
    title: 'расширенный поиск',
    route: '/advanced_search',
    icon: 'icon search',
    regions: ['ru'],
  },
  {
   title: 'все заметки',
    route: '/notes',
    icon: 'icon comment alternate outline',
    regions: ['ru', 'ca', 'by'],
  },
];

export const menuList = menuItems.filter(item => item.regions.includes(REGION));

export default menuList;
